import { useState } from "react";
import { formatINR } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";
import EduSection from "@/components/EduSection";

const DEFAULT = { structure: 40, finishing: 25, electrical: 8, plumbing: 7, fittings: 10, contingency: 10 };

export default function CostPerSqft() {
  const [total, setTotal] = useState("2000000");
  const [area, setArea] = useState("1200");
  const [pcts] = useState(DEFAULT);

  const rate = (Number(total)||0) / (Number(area) || 1);
  const rows = [
    ["Total Cost", formatINR(Number(total)||0)],
    ["Area", `${area} sq ft`],
    ["Cost per sq ft", formatINR(rate)],
    ...Object.entries(pcts).map(([k,v]) => [`${k[0].toUpperCase()+k.slice(1)} (${v}%)`, formatINR((Number(total)||0) * v/100)]),
  ];
  return (
    <div>
      <CalcPageHeader title="Cost per Sq ft Breakdown" description="Understand the per-sqft cost and typical component split of a construction project." slug="cost-sqft" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 grid grid-cols-2 gap-4">
            <Field label="Total Project Cost (₹)"><input data-testid="cps-total" type="number" value={total} onChange={(e)=>setTotal(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Area (sq ft)"><input data-testid="cps-area" type="number" value={area} onChange={(e)=>setArea(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Cost per Sq ft" slug="cost-sqft" highlight={{ label: "₹ per sq ft", value: formatINR(rate) }} rows={rows} note="Breakdown uses typical Indian residential ratios (structure ~40%, finishing ~25%, etc.)." />
        </div>
      </div>
      <EduSection howItWorks={<p>Break-up ratios come from CPWD and industry norms for typical Indian residential construction. Adjust as needed for your project type.</p>} related={["construction","loan-emi","far"]} />
    </div>
  );
}
